import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { enAU } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";

import calendarIcon from "@assets/images/calendar-icon.svg";
import closeIcon from "@assets/images/close.svg";
import { filterCommonStyles } from "@utils/filterCommonStyles";
import { PopupStyle } from "../popup/style";

function StartDatePopup(props) {
  const classes = filterCommonStyles();
  const customRangeModalClasses = PopupStyle();
  const [scroll] = useState("body");

  const minimumDate = new Date(props.data.createJobStartDate);
  return (
    <Dialog
      open={props.open}
      className={customRangeModalClasses.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose} />
      </div>
      <form
        noValidate
        autoComplete="off"
        className={customRangeModalClasses.customForm}
      >
        <DialogTitle>Time Period:</DialogTitle>
        <DialogContent>
          <div className="form-row">
            <div className="form-group">
              <FormControl variant="outlined" className={classes.formControl}>
                <label className="label-text">Start date</label>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enAU}>
                  <KeyboardDatePicker
                    variant="inline"
                    format="dd/MM/yyyy"
                    className="custom-datepicker"
                    keyboardIcon={<img src={calendarIcon} alt="calendar" />}
                    name="createJobStartDate"
                    placeholder="DD/MM/YYYY"
                    value={props.data.createJobStartDate}
                    onChange={(e) => props.handleChange(e, "createJobStartDate")}
                    maxDate={new Date()}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </div>
            <div className="form-group">
              <FormControl variant="outlined" className={classes.formControl}>
                <label className="label-text">End date</label>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enAU}>
                  <KeyboardDatePicker
                    variant="inline"
                    format="dd/MM/yyyy"
                    className="custom-datepicker"
                    name="createJobEndDate"
                    keyboardIcon={<img src={calendarIcon} alt="calendar" />}
                    placeholder="DD/MM/YYYY"
                    value={props.data.createJobEndDate}
                    onChange={(e) => props.handleChange(e, "createJobEndDate")}
                    disabled={!props.data.createJobStartDate}
                    minDate={minimumDate}
                    maxDate={new Date()}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={props.handleSubmit}
            color="primary"
            className="orange-btn primary-btn"
            disabled={
              !props.data.createJobEndDate ||
              props.data.createJobEndDate < props.data.createJobStartDate
            }
          >
            Ok
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default StartDatePopup;
